module.exports = __webpack_public_path__ + "img/work_environment4.3f0123de.png";